export const team_builder_rules_en = [
  // Page 1: Game Introduction & Steps
  "A tool to randomly divide desired players into multiple teams.",
  "1. Set Total Players",
  "Enter the total number of players to be assigned to teams (minimum 2 players)",
  "2. Set Team Count",
  "Set the number of teams to divide into (minimum 2 teams)",
  "3. Start Team Assignment",
  "Once settings are complete, teams will be automatically assigned when you start",
  "4. View Results",
  "You can check the player numbers assigned to each team",

  // Page 2: Assignment Formula & Examples
  "Assignment Formula",
  "Base players = Total players ÷ Number of teams",
  "Remaining players = Total players % Number of teams",
  "If there are remainders, 1 additional player is assigned starting from the first team",
  "Example 1: 10 players into 3 teams",
  "Calculation: 10 ÷ 3 = 3 players + 1 remainder",
  "Team A: 4 players (3 + 1)",
  "Team B: 3 players",
  "Team C: 3 players",
  "Example 2: 12 players into 4 teams",
  "Calculation: 12 ÷ 4 = 3 players (0 remainder)",
  "Team A: 3 players",
  "Team B: 3 players",
  "Team C: 3 players",
  "Team D: 3 players",

  // Page 3: Features & Tips
  "Features & Tips",
  "Features",
  "• Fair random distribution ensures balanced teams",
  "• Color-coded teams for easy identification",
  "• Instant results with clear team assignments",
  "• Perfect for any group size and team count",
  "Usage Tips",
  "• Works great for sports team selection",
  "• Ideal for classroom group activities",
  "• Perfect for party games and events",
  "• Use for workplace team building exercises",
];

export const team_builder_rules_ko = [
  // Page 1: 게임 소개 및 단계
  "원하는 인원을 랜덤하게 여러 팀으로 나누는 도구입니다.",
  "1. 총 인원 수 설정",
  "팀에 배정할 총 인원 수를 입력합니다 (최소 2명)",
  "2. 팀 개수 설정",
  "나눌 팀의 개수를 설정합니다 (최소 2팀)",
  "3. 팀 편성 시작",
  "설정 완료 후 팀 편성을 시작하면 자동으로 팀이 배정됩니다",
  "4. 결과 확인",
  "각 팀별로 배정된 플레이어 번호를 확인할 수 있습니다",

  // Page 2: 배정 공식 및 예제
  "배정 공식",
  "기본 인원 = 총 인원 ÷ 팀 개수",
  "나머지 인원 = 총 인원 % 팀 개수",
  "나머지가 있으면 첫 번째 팀부터 1명씩 추가 배정",
  "예제 1: 10명을 3팀으로",
  "계산: 10 ÷ 3 = 3명 + 나머지 1명",
  "팀 A: 4명 (3 + 1)",
  "팀 B: 3명",
  "팀 C: 3명",
  "예제 2: 12명을 4팀으로",
  "계산: 12 ÷ 4 = 3명 (나머지 0)",
  "팀 A: 3명",
  "팀 B: 3명",
  "팀 C: 3명",
  "팀 D: 3명",

  // Page 3: Features & Tips
  "기능 & 팁",
  "기능",
  "• 공정한 랜덤 분배로 균형잡힌 팀 구성",
  "• 색상 코딩으로 쉬운 팀 구분",
  "• 명확한 팀 배정으로 즉시 결과 확인",
  "• 모든 그룹 크기와 팀 수에 완벽 대응",
  "활용 팁",
  "• 스포츠 팀 선발에 활용하세요",
  "• 교실 그룹 활동에 이상적입니다",
  "• 파티 게임과 이벤트에 완벽합니다",
  "• 직장 팀 빌딩 활동에 사용하세요",
];
